// @ts-nocheck

import React from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { search, clearSearch } from '../../actions/search';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';

import SearchBar from './SearchBar';
import selectSearchBarProps from './SearchBar.selector';

type SearchBarContainerProps = {
  focusOnMount?: boolean;
  onQueryChange?: (query: string) => void;
  onResultsChange?: (results: { matches: Array<unknown>; tournaments: Array<unknown> }) => void;
  mode?: string;
  onLoadingChange?: (isLoading: boolean) => void;
  isSearching?: boolean;
};

const SearchBarContainer = (ownProps: SearchBarContainerProps) => {
  const selectedProps = useSelector(selectSearchBarProps);

  const actions = useMemo(() => ({ search, clearSearch }), []);

  const actionsProps = useBindActionsCreator(actions);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, actionsProps });

  return <SearchBar {...enhancedProps} />;
};

export default SearchBarContainer;
